<template>
<div style="display: none;">TOP PAGE</div>
</template>

<script>
  import {breakpoint, assets_path} from '@/_constant/variables';
  import store from '@/_modules/stores';

  export default {
    data() {
      return {
        breakpoint: breakpoint,
        assets_path: assets_path,
        to: null,
        from: null,
      }
    },
    store,
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.to = to;
        vm.from = from;
      });
    },
    beforeRouteUpdate(to, from, next) {
      this.to = to;
      this.from = from;
      // 削除
      this.destroy();
      // 次へ
      this.$nextTick(this.init);
      next();
    },
    beforeRouteLeave (to, from, next) {
      this.to = to;
      this.from = from;
      this.destroy();
      next();
    },
    mounted() {
      this.$store.commit('setContainerClass', 'c-slanted--top');
      this.$store.commit('setTop', true);

      this.$nextTick(this.init);
    },
    methods: {
      init() {
        const top = document.body.style.top;
        const body = document.body;
        body.style.height = '';
        body.style.overflowY = '';
        body.style.position = '';
        body.style.top = '';

        if (gSLANTED.isDevice !== 'pc') {
          window.scrollTo(0, parseInt(top || '0') * -1);
        }
      },
      stopScroll() {
        const body = document.body;
        body.style.height = '100vh';
        body.style.overflowY = 'hidden';

        if (gSLANTED.isDevice !== 'pc') {
          const scrollY = -window.scrollY;
          body.style.position = 'fixed';
          body.style.top = `${scrollY}px`;
        }
      },
      destroy() {
        if (this.to.name === 'works') {
          this.stopScroll();
        }
      }
    }
  }
</script>